export default "__VITE_ASSET__76f127de__"